<template>
    <span>
        <v-list-tile @click="mostrarCaixaDialogo">
            <v-list-tile-title>
                Cancelar Declaração de Vencedor
            </v-list-tile-title>
        </v-list-tile>
        <v-dialog :max-width="Modal.Confirmacao.larguraMaxima" persistent v-model="visibilidadeDialogo">
            <v-card :min-width="Modal.Confirmacao.larguraMinima" :max-width="Modal.Confirmacao.larguraMaxima">
                <v-card-title class="primary modal-title" primary-title>
                    <span><strong>{{itemOuLoteDescricao}}</strong> | Cancelar declaração de vencedor</span>
                    <v-btn flat depressed @click="fecharCaixaDialogo">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pb-0 az-form-content">
                    <div class="az-text mb-3">
                        <label>Fornecedor</label>
                        <p>{{razaoSocial}}</p>
                    </div>

                    <v-textarea v-model="motivo"
                                :error-messages="errors.collect('Motivo ' + itemOuLoteDescricao)"
                                v-validate="'required'"
                                :name="'Motivo ' + itemOuLoteDescricao"
                                label="Motivo"
                                placeholder="Digite aqui o motivo"
                                rows="3"
                                maxlength="1000"
                                :counter="1000"/>
                </v-card-text>

                <v-card-actions class="px-3 py-2">
                    <v-btn color="botao-cancelar-color" flat outline @click="fecharCaixaDialogo">
                        Fechar
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn id="botaoConfirmar" color="primary" depressed @click="confirmarCancelamento">
                        Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </span>
</template>

<script>
import { Modal } from '@/core/constants'

export default {
    name: 'AcoesCancelarDeclaracaoVencedor',
    $_veeValidate: {
        validator: 'new'
    },
    props: ['itemOuLoteDescricao', 'razaoSocial'],
    data() {
        return {
            visibilidadeDialogo: false,
            motivo: null,
            Modal
        }
    },
    methods: {
        async confirmarCancelamento(){
            await this.validarPreenchimento()
            this.$emit('cancelarDeclaracaoVencedor', this.motivo)
            this.fecharCaixaDialogo()
        },
        async validarPreenchimento() {
            const estaValidado = await this.$validator.validate('Motivo ' + this.itemOuLoteDescricao)
            if (!estaValidado) {
                throw new Error('Preencha o motivo do cancelamento')
            }
        },
        mostrarCaixaDialogo() {
            setTimeout(() => {
                this.limparCampos()
                this.visibilidadeDialogo = true
            }, 500)
        },
        fecharCaixaDialogo() {
            this.limparCampos()
            this.visibilidadeDialogo = false
        },
        limparCampos() {
            this.motivo = null
            this.$validator.reset()
        }
    },
    destroyed() {
        this.fecharCaixaDialogo()
    }
}
</script>

<style scoped lang="stylus">
    .modal-title
        justify-content space-between

        .v-btn
            padding 0
            margin 0
            color #fff
            box-sizing border-box
            min-width 25px

    .botao-primario
        padding 0 25px
        border 1px solid var(--v-primary-base) !important
        background-color var(--v-primary-base) !important
        color #fff !important
        box-sizing border-box
        margin-left 15px !important
</style>